import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/35_winter_house/35_winter_house"
 * Contains 1 texture(s)
 */
export class Desktop35WinterHouseAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/35_winter_house/35_winter_house';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '35_winter_house.png'
    ] as const;
}
